import React, { useEffect, useState } from 'react';
import { Header, Segment, Button, Modal } from 'semantic-ui-react';
import { connect } from 'react-redux'
import moment from 'moment'

import TitleBar from '../titleBar/titleBar';
import AgGridTable from '../agGridComponent/agGridTable';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';
import EditModal from '../modals/editModal';


import PaymentActionButton from './paymentActionButton';
import PaymentApprovalModal from './paymentApprovalModal';

import { deletePayment, getPayments, getFilteredPayments } from '../../redux/actions/paymentActions'; 
import { approvePayments, rejectPayments } from '../../redux/actions/approvalActions';


function PaymentsTable(props) {
    
    const { paymentsData, paymentsLoading, getPayments, deletePayment, deletePaymentIsLoading, approvePayments, rejectPayments, getFilteredPayments } = props;

    useEffect(() => {
        getPayments()
    }, [getPayments]);

    const [ selectedRows, setSelectedRows ] = useState([]);
    const [ activeSelect, setActiveSelect ] = useState(false);
    const [ openApprovalModal, setOpenApprovalModal] = useState(false);
    const [grid, setGrid] = useState({});


    const getSelectedRows = (grid) => {

        const selected = grid.api.getSelectedRows()
        setGrid(grid)

        setSelectedRows(selected);
        if (selected.length > 0) {
            setActiveSelect(true)
        } else {
            setActiveSelect(false)
        }
    }

    const approvePaymentsSelected = () => {
        
        let payementDetails = [];
        selectedRows && selectedRows.map((o,i) => {
            let temp = {};
            temp.paymentReferenceNo = o.refNo
            temp.vendorCode = o.vendorCode
            temp.approvalStatus = "Approved"

            payementDetails[i] = temp
        })

        const approveData = {
            customerNo: localStorage.getItem('customerNo'),
            userId: localStorage.getItem('userId'),
            payementDetails: payementDetails
        }
        
        approvePayments(approveData)
    };

    const rejectPaymentsSelected = () => {

        let payementDetails = [];
        selectedRows && selectedRows.map((o,i) => {
            let temp = {};
            temp.paymentReferenceNo = o.refNo
            temp.vendorCode = o.vendorCode
            temp.approvalStatus = "Rejected"

            payementDetails[i] = temp
        })

        const rejectData = {
            customerNo: localStorage.getItem('customerNo'),
            userId: localStorage.getItem('userId'),
            payementDetails: payementDetails
        }
        
        rejectPayments(rejectData)
    }

    const handleSelectAll = () => {
        grid.api.selectAll()
    }

    const handleUnSelectAll = () => {
        grid.api.deselectAll()
    }

    const handleCancel = () => {
        console.log("Grid State", grid)
        grid.api.deselectAll();
        setActiveSelect(false);
    }

    const getFilterDates = (val,startDate, endDate) => {

        const filteredData = {
            api_token: localStorage.getItem('apiToken'),
            customerNo: localStorage.getItem('customerNo'),
            userId: localStorage.getItem('userId'),
            fromDate:startDate != null ?  moment(startDate).format("DD-MM-YYYY") : null,
            toDate:endDate != null  ? moment(endDate).format("DD-MM-YYYY") : null
        }

        getFilteredPayments(filteredData)
    }

    const refreshDates = () => {
        window.location.reload();
    }


        let columnDefs = [
            {headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, checkboxSelection: true, maxWidth: 70},
            { headerName: 'Payment No.', field: 'paymentNo', tooltipField: 'paymentNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Reference No.', field: 'refNo', tooltipField: 'refNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Partner Name', field: 'vendorName', tooltipField: 'vendorName', enableRowGroup: true, enablePivot: true, filter: true },
            // { headerName: 'Vendor Group', field: 'vendorGroup', tooltipField: 'vendorGroup', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Payment Amount (Rs)', field: 'paymentAmount', tooltipField: 'paymentAmount', enableRowGroup: true, enablePivot: true, filter: true },
            // { headerName: 'Payment Mode', field: 'paymentMode', tooltipField: 'paymentMode', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Payment Date', field: 'paymentDate', tooltipField: 'paymentDate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Status', field: 'status', tooltipField: 'status', enableRowGroup: true, enablePivot: true, filter: true , 
                cellStyle: params => {
                    if(params.value === 'Approved'){
                        return { color: 'green'}
                    } else if (params.value === 'Rejected') {
                        return { color: 'red'}
                    } else {
                        return { color: 'grey'}
                    } 
                }
            },
            { headerName: 'Created On', field: 'createdOn', tooltipField: 'createdOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created By', field: 'createdBy', tooltipField: 'createdBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Modified On', field: 'modifiedOn', tooltipField: 'modifiedOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Modified By', field: 'modifiedBy', tooltipField: 'modifiedBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Edit/Delete', field: 'edit', cellRenderer: 'actionRenderer', suppressToolPanel: true, pinned: "right" }
        ] 
        
        let columnKeys = ['paymentNo', 'refNo', 'vendorName', 'paymentAmount', 'paymentDate', 'status', 'createdOn', 'createdBy', 'modifiedOn', 'modifiedBy']

        let frameworkComponents = {
            actionRenderer: PaymentActionButton,
        }

        let rowData = []

        paymentsData && paymentsData.forEach((object, index) => {
            let temp = {}
            temp.paymentNo = object.paymentNo
            temp.paymentId = object.paymentId
            temp.refNo = object.paymentReferenceNo
            temp.vendorName = object.vendorName
            temp.vendorCode = object.vendorCode
            temp.vendorGroup = ''
            temp.paymentAmount = object.paidAmount
            temp.paymentMode = object.paymentModeName
            temp.paymentDate = moment(object.paymentDate).format('DD-MM-YYYY') === 'Invalid date' ? '' : moment(object.paymentDate).format('DD-MM-YYYY')
            temp.status = object.approvalStatus
            temp.createdOn = object.createdOn
            temp.createdBy = object.createdByName
            temp.modifiedOn = object.updatedOn
            temp.modifiedBy = object.updatedByName
            temp.deletePayment = deletePayment
            temp.isLoading = deletePaymentIsLoading
            rowData[index] = temp   
        })

        const pendingBills = paymentsData ? paymentsData.filter(payment => payment.approvalStatus === 'Pending').length : ''
        const approvedBills = paymentsData ? paymentsData.filter(payment => payment.approvalStatus === 'Approved').length : ''
        const rejectedBills = paymentsData ? paymentsData.filter(payment => payment.approvalStatus === 'Rejected').length : ''

        const approvalData = {
            pending: pendingBills,
            approved: approvedBills,
            rejected: rejectedBills
        }

        return (
            <React.Fragment>
                <div style={{ position: 'relative' }}>
                    <AgGridTable
                        columnDefs={columnDefs}
                        rowData={rowData}
                        searchValue={props.searchValue}
                        link="/add-payment"
                        baseURL={props}
                        hiddenNewPopupBtn={true}
                        hiddenImportPopupBtn={true}
                        columnKeys={columnKeys}
                        extraComponents={frameworkComponents}
                        titleBarTitle="Payments"
                        handleSearch={props.handleSearch}
                        rowSelected={getSelectedRows}
                        approvalCountSection={true}
                        approvalData={approvalData}
                        dateFilter={true}
                        isRowSelectable={function (rowNode) {
                            return rowNode.data && rowNode.data.status === "Approved" ? false  : true;
                        }}
                        getFilterDates={getFilterDates}
                        refreshDates={refreshDates}
                        suppressRowSelection={true}
                        dataLoading={paymentsLoading}
                        payments={true}
                    />
                    {activeSelect ? 
                        
                            
                        <Segment
                            style={{ position: 'absolute', bottom: 12, left: 0 }}
                        >
                            <span style={{ color: 'grey', fontSize: '14px' }}>{`Selected (${selectedRows.length}/${paymentsData.length}) `}</span>
                            { selectedRows.length === paymentsData.length ?
                                <Button onClick={handleUnSelectAll} size="mini" color="blue" style={{ marginLeft: '20px', borderRadius: '25px' }}>UnSelect All</Button>
                                :
                                <Button onClick={handleSelectAll} size="mini" color="blue" style={{ marginLeft: '20px', borderRadius: '25px' }}>Select All</Button>

                            }
                            <Button onClick={approvePaymentsSelected} size="mini" basic color="blue" style={{ marginLeft: '5px', borderRadius: '25px' }}>Approve</Button>
                            <Button onClick={rejectPaymentsSelected} size="mini" basic color="red" style={{ marginLeft: '5px', borderRadius: '25px' }}>Reject</Button>
                            <Button type="button" onClick={handleCancel} size="mini" style={{ marginLeft: '5px', borderRadius: '25px' }}>Cancel</Button>
                        </Segment>
     
                        :

                        ""
                    }
                </div>
            </React.Fragment>
        )
    }
const mapStatetoProps = (state) => ({
    paymentsData: state.getPaymentsData.payments.data,
    paymentsLoading: state.getPaymentsData.isLoading,
    deletePaymentIsLoading: state.deletePaymentData.isLoading
})

export default connect(mapStatetoProps, { getPayments, deletePayment, approvePayments, rejectPayments, getFilteredPayments })(PaymentsTable)